import { render, staticRenderFns } from "./DragZone.vue?vue&type=template&id=1b2e71ba&scoped=true&"
import script from "./DragZone.vue?vue&type=script&lang=js&"
export * from "./DragZone.vue?vue&type=script&lang=js&"
import style0 from "./DragZone.vue?vue&type=style&index=0&id=1b2e71ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2e71ba",
  null
  
)

export default component.exports